import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router';

import { selectCustomer } from '../../store/modules/customers/selectors';
import { useActionDispatcher } from '../../hooks';
import { getCustomerRequest, saveCustomerRequest, resetCurrentCustomer } from '../../store/modules/customers/actions';
import CustomerForm from './CustomerForm';


const CustomerEdit = () => {
  const dispatch = useDispatch();
  const customer = useSelector(selectCustomer);

  const match = useRouteMatch<{
    id: string;
  }>()!;

  const customerId = customer.data?.id;
  useEffect(() => {
    const matchId = parseInt(match.params.id, 10);
    if (!customerId || matchId !== customerId) {
      dispatch(getCustomerRequest(matchId));
    }
  }, [dispatch, match.params.id, customerId]);

  useEffect(() => () => {
    dispatch(resetCurrentCustomer());
  }, [dispatch]);

  const saveCustomer = useActionDispatcher(saveCustomerRequest);

  return <CustomerForm record={customer} onSubmit={saveCustomer} />;
};

export default CustomerEdit;
